import { Component, OnDestroy, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { UserService } from 'app/shared/services/user.service';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { FeedbackService } from 'app/shared/services/feedback.service';

@Component({
  selector: 'feedbackComponent',
  templateUrl: './dlgFeedback.component.html',
  styleUrls: ['./dlgFeedback.component.scss'],
})
export class FeedbackComponent implements OnInit, OnDestroy {

  form: UntypedFormGroup;
  feedback = '';

  constructor(
    public dialogRef: MatDialogRef<FeedbackComponent>,
    public userService: UserService,
    private fb: UntypedFormBuilder,
    private feedbackService: FeedbackService,
  ) {
  }

  ngOnInit() {
     // build the form
     this.form = this.fb.group({
      feedback: [this.feedback, Validators.compose([Validators.required, Validators.maxLength(500)])]
    });
  }

  ngOnDestroy() {
  }

  sendFeedback()
  {
    this.feedbackService.postFeedback(this.feedback);
    this.dialogRef.close();
  }
}
